import { render, staticRenderFns } from "./onlineTrainingDetail.vue?vue&type=template&id=20e902fc&scoped=true&"
import script from "./onlineTrainingDetail.vue?vue&type=script&lang=js&"
export * from "./onlineTrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./onlineTrainingDetail.vue?vue&type=style&index=0&id=20e902fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e902fc",
  null
  
)

export default component.exports